import axios, { AxiosError } from "axios";
import { headers } from "../../../config/config";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";
import { request } from "../api";

const { Bearer } = AUTHORIZATION;
const { post, put } = request;
const initialRoute = "member/enrollment";

type editBeneficiaryPayload = {
	old_password: string;
	new_password: string;
};

export const editBeneficiary = async (_payload: any) => {
	try {
		const endpoint = `${initialRoute}/edit-beneficiary`;
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		const response = await put(endpoint, _payload, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			// console.log(response);
			const {
				data: { result }
			} = response;
			if (result === "beneficiary updated successfully") {
				return true;
			}
			return false;
		}
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		throw err;
	}
};
